import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import { useProductDetails } from "@hooks/useProduct";
import type { Plan, ProductType } from "@memorang/types";
import { CustomSnackbar } from "@memorang/ui";
import { router } from "expo-router";
import { useState } from "react";
import { purchaseUrlMap } from "../../constants";
import RestorePurchaseContent from "../IAPModal/RestorePurchase/RestorePurchaseContent";
import PurchaseContainerBase from "./PurchaseContainerBase";

const PurchaseContainer = ({
	handleClose,
	productType,
	fromHomePage,
}: {
	handleClose: () => void;
	productType?: ProductType;
	fromHomePage?: boolean;
}) => {
	const { data: productDetails } = useProductDetails();
	const { explicitCallTrackCustomEvent } = useAnalytics();

	const numericId = productDetails?.numericId;

	const [showError, setShowError] = useState(false);
	const [showRestorePurchaseDialog, setShowRestorePurchaseDialog] =
		useState(false);

	const handleShowRestorePurchaseDialog = () => {
		setShowRestorePurchaseDialog(true);
	};

	const handlePurchase = (selectedPlan?: Plan) => {
		handleClose();
		if (!numericId) {
			return;
		}
		const customPurchaseUrl = purchaseUrlMap[numericId]?.purchaseUrl;
		if (customPurchaseUrl) {
			window.open(customPurchaseUrl, "_blank");
		} else {
			explicitCallTrackCustomEvent({
				eventName: events.paymentSubmitted,
				planId: selectedPlan?.id,
				product_id: numericId,
				plan_amount: selectedPlan?.amount,
				plan_duration: selectedPlan?.duration,
				plan_interval: selectedPlan?.interval,
				plan_currency: selectedPlan?.currency,
			});
			router.push({
				pathname: "/(protected)/purchase/[id]/checkout",
				params: {
					id: numericId,
					planId: selectedPlan?.id,
				},
			});
		}
	};

	return (
		<>
			{!showRestorePurchaseDialog && (
				<PurchaseContainerBase
					handleClose={handleClose}
					fromHomePage={fromHomePage}
					productType={productType}
					handlePurchase={handlePurchase}
					handleShowRestorePurchaseDialog={handleShowRestorePurchaseDialog}
					purchaseInProgress={false}
				/>
			)}
			{showRestorePurchaseDialog && (
				<RestorePurchaseContent
					handleDismiss={() => setShowRestorePurchaseDialog(false)}
					handleClose={handleClose}
				/>
			)}
			{showError && (
				<CustomSnackbar
					handleDismiss={() => setShowError(false)}
					visible={showError}
					duration={2000}
					message="Something went wrong while creating a checkout, try again"
				/>
			)}
		</>
	);
};

export default PurchaseContainer;
